import React from 'react';
import styles from './ToggleShowRequests.module.scss'
import { Switch, Icon, Typography } from 'antd';
import cn from 'classnames';

const { Text } = Typography;

export const ToggleShowRequests = ({ enabled, onChange }) => {
  return (
    <div className={cn(styles.root, { [styles.activeContainer]: enabled })}>
      <Switch
        checkedChildren={<Icon type="check" />}
        unCheckedChildren={<Icon type="close" />}
        checked={enabled}
        onChange={onChange}
      />
      <Text className={cn(styles.text, { [styles.active]: enabled })}>
        Показывать заявки
      </Text>
    </div>
  );
}